module.exports = __webpack_public_path__ + "static/media/CRCA-logo.b85acc6e.jpg";